import * as CONST from "./actionTypes";

export const getContent = (data, callback) => ({
  type: CONST.GET_CONTENT,
  payload: {data, callback},
});




export const getContentSuccess = (data) => ({
  type: CONST.GET_CONTENT_SUCCESS,
  payload: data,
});

export const getContentFail = (error) => ({
  type: CONST.GET_CONTENT_FAIL,
  payload: error,
});




